<ng-container *ngIf="vm$ | async as vm; else loading">
  <div class="unit-home-page">
    <span class="development-ribbon">En desarrollo</span>
    <!-- Content Grid -->
    <div class="content-container">
      <div class="cards-grid" *ngIf="vm.canViewData && (hasActivity$ | async)">
        <div class="card-wrapper">
          <app-unit-last-attendance-card
            [members]="vm.lastAttendance.data"
            [isLoading]="vm.lastAttendance.isLoading"
            [errorMessage]="vm.lastAttendance.errorMessage"
            [showCommunity]="vm.unit.organizationLevelId < 5"
            (retryLoad)="retryLastAttendance()">
          </app-unit-last-attendance-card>
        </div>

        <div class="card-wrapper">
          <app-unit-home-attendance-card [unitId]="vm.unit.id"></app-unit-home-attendance-card>
        </div>

      </div>

    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
